/* # Root */

.root {
	container-type: inline-size;
	flex: 2;
}

/* # Links */

.root :global(.mantine-Anchor-root) {
	font-size: inherit;
	font-weight: 500;
}

.root strong :global(.mantine-Anchor-root) {
	font-weight: inherit;
}

/* # Misc. */

.status {}

.buttonGoToBottom {
	position: absolute;
	bottom: .5rem;
	border: 3px solid var(--mantine-color-body);
}
